import React, { useEffect, useMemo, useState } from 'react';
import DOMPurify from 'dompurify';
import './collectionPopup.css';

function CollectionPopup({ article }) {
    const [current, setCurrent] = useState(0);
    const articleKey = article?.id;
    const images = useMemo(() => {
        const sourceImages = (article?.ImagesURL || article?.imagesURL || article?.Thumbnails || []);
        const imageArray = Array.isArray(sourceImages) ? sourceImages : [sourceImages];
        if (imageArray.length === 0 && article?.thumbnail) {
            return [article.thumbnail];
        }
        return imageArray.filter(Boolean);
    }, [article]);

    useEffect(() => {
        setCurrent(0);
    }, [articleKey]);

    const articleContent = useMemo(
        () => DOMPurify.sanitize(article?.articleContent || ''),
        [article?.articleContent]
    );
    const articleTitle = article?.name || 'Article';

    const prevImage = () => {
        setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const nextImage = () => {
        setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className="collection-popup-container">
            <div className="collection-popup-carousel-section">
                <div className="collection-popup-imageCarousel">
                    {images.map((url, idx) => (
                        <img
                            key={`${url}-${idx}`}
                            src={url}
                            alt={`${article?.title || 'Article'} ${idx + 1}`}
                            className={`carousel-media ${idx === current ? 'active' : ''}`}
                            loading={idx === current ? 'eager' : 'lazy'}
                            decoding="async"
                        />
                    ))}

                    {images.length > 1 && (
                        <>
                            <button className="collection-popup-prevButton" onClick={prevImage} aria-label="Image précédente">
                                <span className="collection-popup-directionButton-span">‹</span>
                            </button>
                            <button className="collection-popup-nextButton" onClick={nextImage} aria-label="Image suivante">
                                <span className="collection-popup-directionButton-span">›</span>
                            </button>
                        </>
                    )}

                    <div className="collection-popup-indicators">
                        {images.map((_, idx) => (
                            <span key={idx} className={`collection-popup-indicator ${idx === current ? 'active' : ''}`} />
                        ))}
                    </div>
                </div>
            </div>

            <div className="collection-popup-info-section">
                <div className="collection-popup-title">
                    <h2>{articleTitle}</h2>
                    {(article?.author || article?.Author) && <p className="collection-popup-author">{article?.author || article?.Author}</p>}
                </div>

                <div className="collection-popup-content-section">
                    {articleContent ? (
                        <div className="collection-popup-content" dangerouslySetInnerHTML={{ __html: articleContent }} />
                    ) : (
                        <p className="collection-popup-empty-content">Cet article n’a pas encore de contenu publié.</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default CollectionPopup;